export default {
    "DeFi Binance": "DeFi Binance",
    "流动性挖矿": "Liquiditäts-Mining",
    "加入节点， 开始挖矿": "Node beitreten, Mining starten",
    "参 与": "Teilnehmen",
    "矿池数据": "Pool-Daten",
    "总产量": "Gesamtausstoß",
    "有效节点": "Aktive Nodes",
    "参与者": "Teilnehmer",
    "用户收入": "Benutzereinkommen",
    "挖矿榜单": "Mining-Rangliste",
    "流动性挖矿收入": "Einnahmen aus Liquiditäts-Mining",
    "输出记录": "Ausgabelog",
    "地址": "Adresse",
    "数量": "Menge",
    "帮助中心": "Hilfe-Center",
    "希望它可以帮助你": "Wir hoffen, es hilft dir",
    "安全保障": "Sicherheitsgarantie",
    "我们有安全的审计报告": "Wir haben Sicherheitsprüfberichte",
    "伙伴": "Partner",
    "我们的商业伙伴": "Unsere Geschäftspartner",
    "首页": "Startseite",
    "我的矿池": "Mein Pool",
    "提取": "Abheben",
    "账户": "Konto",
    "总挖矿金额": "Gesamt-Mining-Betrag",
    "可更换": "Austauschbar",
    "收益率": "Rendite",
    "币池名称": "Pool-Name",
    "最低金额": "Mindestbetrag",
    "收益率/24小时": "Rendite/24h",
    "挖矿记录": "Mining-Protokolle",
    "金额": "Betrag",
    "描述": "Beschreibung",
    "时间": "Zeit",
    "已参与": "Teilgenommen",
    "质 押": "Staken",
    "已质押": "Gestaked",
    "记录": "Aufzeichnen",
    "兑换": "Umtausch",
    "从": "Von",
    "全部": "Alle",
    "至": "Bis",
    "价格": "Preis",
    "确认": "Bestätigen",
    "矿池收益": "Pool-Einnahmen",
    "今日收益": "Heutige Einnahmen",
    "普通矿池": "Standard-Pool",
    "高级矿池": "Premium-Pool",
    "全部的": "Alle",
    "可用的": "Verfügbar",
    "申请加入": "Antrag auf Beitritt",
    "推荐朋友": "Freunde empfehlen",
    "一起赚取加密货币": "Gemeinsam Krypto verdienen",
    "查看详情": "Details ansehen",
    "团队": "Team",
    "推荐": "Empfehlung",
    "团队规模": "Teamgröße",
    "直接发起人": "Direkter Sponsor",
    "总收入": "Gesamteinnahmen",
    "今天的收入": "Heutiges Einkommen",
    "我的推荐链接": "Mein Empfehlungslink",
    "复制": "Kopieren",
    "1. 获取链接": "1. Link erhalten",
    "2. 邀请朋友": "2. Freunde einladen",
    "3. 赚取加密货币": "3. Krypto verdienen",
    "等级": "Level",
    "1 级": "Level 1",
    "2 级": "Level 2",
    "3 级": "Level 3",
    "用户地址": "Benutzeradresse",
    "币种": "Token",
    "说明": "Details",
    "状态": "Status",
    "定时收益": "Geplante Einnahmen",
    "今日预收益": "Erwartete Einnahmen heute",
    "累计收益": "Gesamteinnahmen",
    "将矿池收益的BNB兑换成USDT后立即到账": "BNB-Einnahmen sofort in USDT umwandeln",
    "将USDT提取后会在24小时内到达你的钱包": "USDT-Auszahlung erfolgt innerhalb von 24h",
    "天": "Tage",
    "高级矿池收益": "Premium-Pool-Einnahmen",
    "质押收益": "Staking-Einnahmen",
    "下次收益": "Nächste Einnahmen",
    "当前收益率": "Aktuelle Rendite",
    "昨日收益": "Gestern verdient",
    "普通矿池收益率": "Standard-Pool-Rendite",
    "高级矿池收益率": "Premium-Pool-Rendite",
    "高级矿池限时开放": "Premium-Pool zeitlich begrenzt",
	"公告":"Bekanntmachung",
	"我知道了":"Ich verstehe"
};
